import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify, slasher } from "../helpers";
import VisibilitySensor from "react-visibility-sensor";

class IndustriesSubTile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasAppeared: false
        };

        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive(isVisible) {
        isVisible === true ? this.setState({ hasAppeared: true }) : "";
    }

    render() {
        const slug = this.props.sectors.name,
            sanitized = slugify(slug),
            parent = this.props.sectors.parentName,
            parSlug = slugify(parent),
            url = `/industries/${parSlug}/${sanitized}/`,
            slash = slasher(this.props.sectors.name);

        return (
            <VisibilitySensor onChange={this.toggleActive}>
                {({ isVisible }) => (
                    <Link
                        className={`tile__link ${
                            this.state.hasAppeared ? "is-visible" : ""
                        }`}
                        to={{ pathname: url }}
                        data-cta={`Sector Tile: ${parent}: ${slug}`}
                    >
                        <article className="tile tile--sub">
                            <button className="tile__link">
                                <h3 className="tile__name">{slash}</h3>
                            </button>
                        </article>
                    </Link>
                )}
            </VisibilitySensor>
        );
    }
}

export default IndustriesSubTile;



// WEBPACK FOOTER //
// ./src/components/IndustriesSubTile.js